import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';
import { Activity } from 'src/app/model/options/activity';
import { Service } from 'src/app/model/options/service';
import { ExpressionBlock } from 'src/app/model/search-filters/expression-block';
import { Filter } from 'src/app/model/search-filters/filter';
import { SearchFilterLanguageType } from 'src/app/model/search-filters/search-filter-language';
import { StudioType } from 'src/app/model/studio-type';

@Component({
  selector: 'gymfinder-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  standalone: false,
})
export class FilterComponent implements OnInit {
  @Input()
  filter: Filter;

  @Output()
  filterChange = new EventEmitter<Filter>();

  @Input()
  studioTypes: StudioType[];

  @Input()
  services: Service[];

  @Input()
  activities: Activity[];

  @Input()
  gymEquipments: string[];

  @Input()
  gymInfos: string[];

  @Input()
  gymTypes: string[];

  @Input()
  networks: string[];

  @Input()
  equipmentsToBring: string[];

  @Input()
  geniusFeatures: string[];

  private _slug?: string;

  private _text: SearchFilterLanguageType;

  private _block: ExpressionBlock;

  private _synonyms?: string[];

  ngOnInit(): void {
    this._slug = this.filter.slug;
    this._text = this.filter.text;
    this._block = this.filter.block;
    this._synonyms = this.filter.synonyms;
  }

  get slug(): string | undefined {
    return this._slug;
  }

  set slug(newValue: string | undefined) {
    this._slug = newValue;
    this.filter.slug = newValue || undefined;
    this.filterChange.emit(this.filter);
  }

  get text(): SearchFilterLanguageType {
    return this._text;
  }

  set text(newValue: SearchFilterLanguageType) {
    this._text = newValue;
    this.filter.text = newValue;
    this.filterChange.emit(this.filter);
  }

  get block(): ExpressionBlock {
    return this._block;
  }

  set block(newValue: ExpressionBlock) {
    this._block = newValue;
    this.filter.block = newValue;
    this.filterChange.emit(this.filter);
  }

  public get synonyms(): string[] | undefined {
    return this._synonyms;
  }

  public set synonyms(newValue: string[] | undefined) {
    this._synonyms = newValue;
    this.filter.synonyms = newValue;
    this.filterChange.emit(this.filter);
  }

  public removeSynonym(synonym: string) {
    const filteredSynonyms = this._synonyms?.filter(s => s !== synonym);
    this.synonyms =
      filteredSynonyms?.length === 0 ? undefined : filteredSynonyms;
  }

  public addSynonym(event: MatChipInputEvent) {
    const value = event.value?.trim();
    if (!value || value.length === 0) {
      return;
    }
    const currentSynonyms = this._synonyms || [];

    const valueToCheck = value.toLocaleLowerCase();

    if (
      currentSynonyms.findIndex(c => c.toLocaleLowerCase() === valueToCheck) ===
      -1
    ) {
      this.synonyms = [...currentSynonyms, value];
      event.chipInput?.clear();
    }
  }
}
